<template>
  <div>
    <el-table :data="items" v-loading="loading" size="small" class="mt-10">
      <el-table-column label="成品编号(分类)" min-width="100">
        <template slot-scope="scope"
          >{{ scope.row.code }}（{{ scope.row.name }}）</template
        >
      </el-table-column>
      <el-table-column label="上报基地" align="center" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.base.name
          }}{{
            scope.row.well.well_number
              ? `（${scope.row.well.well_number}）`
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="上报人"
        prop="user_name"
      ></el-table-column>
      <el-table-column align="center" label="操作日期">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="使用日期">
        <template slot-scope="scope">
          {{ $time(scope.row.used_date).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="工作时长" prop="used_hour">
      </el-table-column>
      <el-table-column align="center" label="使用区块">
        <template slot-scope="scope">
          {{ scope.row.used_extra[0].value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="井队号">
        <template slot-scope="scope">
          {{ scope.row.used_extra[1].value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="井号">
        <template slot-scope="scope">
          {{ scope.row.used_extra[2].value }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="备注/图片/视频" min-width="140">
        <template slot-scope="scope">
          <div v-html="scope.row.remark.split('<br/>').pop()"></div>
          <div class="medio-container">
            <el-image
              v-for="url in scope.row.imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row.imgs"
            >
            </el-image>
            <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
}
</script>
